import {
  Box,
  Chip,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import {
  activityStatusColorMap,
  activityStatusLabel,
} from '@/constants/idp/activity-status';
import { ActivityStatus, type Activity } from '@/data/idp/plans/interfaces';

export type ActivitiesListProps = {
  activities: Activity[];
  limit?: number;
};

export const Loading = () => {
  return (
    <Stack gap="2px">
      <Skeleton variant="rectangular" height={30} width="100%" />
      <Skeleton variant="rectangular" height={30} width="100%" />
      <Skeleton variant="rectangular" height={30} width="100%" />
      <Skeleton variant="rectangular" height={30} width="100%" />
    </Stack>
  );
};

export const ActivitiesList = ({
  activities: allActivities,
  limit = Infinity,
}: ActivitiesListProps) => {
  const orderedActivities = allActivities
    ?.slice()
    .sort(
      (a, b) =>
        Number(b.status === ActivityStatus.InProgress) -
        Number(a.status === ActivityStatus.InProgress)
    );

  const activities = orderedActivities?.slice(0, limit);
  const hiddenActivitiesCount =
    (limit > 0 && allActivities.length - activities.length) || 0;

  if (!activities.length) {
    return null;
  }

  return (
    <Stack spacing={1} alignItems="start">
      <List
        disablePadding
        sx={{
          bgColor: 'background.paper',
          borderColor: 'divider',
          borderStyle: 'solid',
          borderWidth: 1,
          borderBottomWidth: 0,
          width: '100%',
        }}
      >
        {activities?.map((activity) => {
          const { backgroundColor, color } =
            activityStatusColorMap[activity.status];

          return (
            <ListItem disablePadding divider key={activity.id}>
              <ListItemButton
                LinkComponent="a"
                href={`/pdi/planos/${activity.plan_id}?atividade=${activity.id}`}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  width="100%"
                  gap={2}
                >
                  <ListItemText
                    primary={<Typography>{activity.title}</Typography>}
                  />
                  <Chip
                    label={activityStatusLabel[activity.status]}
                    style={{ backgroundColor, color }}
                  />
                </Stack>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      {hiddenActivitiesCount ? (
        <Box display="flex" justifyContent="flex-end" width="100%">
          <Typography color="neutral.500">
            +{hiddenActivitiesCount} atividades
          </Typography>
        </Box>
      ) : null}
    </Stack>
  );
};
